import { MonthCodeType } from "@/services/models-service"

export const ipv4Regex =
  /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
export const MacAddrRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

export const colorRegexp = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export const Regexp = {
  companyCodeRegexp: /^ОПК\d{2}-\d_\d{3}$/,
  numberRegexp: /^\d{1,4}$/,
  mptAssignment: /^[A-Za-zА-Яа-я]{1,2}-\d{1,4}$/,
}


export const notificationSoundFiles: string[] = [
  'siren.mp3',
  'alarm_ring.mp3',
];

export interface IMonth {
  id: number,
  name: string,
  shortName: string,
  code: MonthCodeType
}

export const months: IMonth[] = [
  {id: 1, name: "Январь", shortName: "Янв", code: "january"},
  {id: 2, name: "Февраль", shortName: "Фев", code: "february"},
  {id: 3, name: "Март", shortName: "Мар", code: "march"},
  {id: 4, name: "Апрель", shortName: "Апр", code: "april"},
  {id: 5, name: "Май", shortName: "Май", code: "may"},
  {id: 6, name: "Июнь", shortName: "Июн", code: "june"},
  {id: 7, name: "Июль", shortName: "Июл", code: "july"},
  {id: 8, name: "Август", shortName: "Авг", code: "august"},
  {id: 9, name: "Сентябрь", shortName: "Сен", code: "september"},
  {id: 10, name: "Октябрь", shortName: "Окт", code: "october"},
  {id: 11, name: "Ноябрь", shortName: "Ноя", code: "november"},
  {id: 12, name: "Декабрь", shortName: "Дек", code: "december"},
];

export const months_list: any[] = [
  {id: 1, name: "Январь", shortName: "Янв", code: "january", months: [1]},
  {id: 2, name: "Февраль", shortName: "Фев", code: "february", months: [2]},
  {id: 3, name: "Март", shortName: "Мар", code: "march", months: [3]},
  {id: 4, name: "Апрель", shortName: "Апр", code: "april", months: [4]},
  {id: 5, name: "Май", shortName: "Май", code: "may", months: [5]},
  {id: 6, name: "Июнь", shortName: "Июн", code: "june", months: [6]},
  {id: 7, name: "Июль", shortName: "Июл", code: "july", months: [7]},
  {id: 8, name: "Август", shortName: "Авг", code: "august", months: [8]},
  {id: 9, name: "Сентябрь", shortName: "Сен", code: "september", months: [9]},
  {id: 10, name: "Октябрь", shortName: "Окт", code: "october", months: [10]},
  {id: 11, name: "Ноябрь", shortName: "Ноя", code: "november", months: [11]},
  {id: 12, name: "Декабрь", shortName: "Дек", code: "december", months: [12]},
];

export const months_dict: any = {
  "january": "Январь",
  "february": "Февраль",
  "march": "Март",
  "april": "Апрель",
  "may": "Май",
  "june": "Июнь",
  "july": "Июль",
  "august": "Август",
  "september": "Сентябрь",
  "october": "Октябрь",
  "november": "Ноябрь",
  "december": "Декабрь",
};

export const type_cut = [
  {id: 1, name: "Бизнес-план"},
  {id: 2, name: "Факт-прогноз"},
  {id: 3, name: "Пользовательская"}
]

export const biling_methods: string[] = [
  "УУТЭ",
  "УУТЭ (с 13 квитанцей)",
  "Норматив",
]

export const view_tarif: string[] = ["Цена", "Тариф"]

export const sign_internal_turnover: string[] = ["ВГО", "ВНО"]

export const value_group: string[] = [
  "Сторонние поставщики",
  "Промышленные потребители",
  "УК, ТСЖ, ЖСК",
  "Оптовые потребители перепродавцы (ОПП)",
  "Бюджетные организации",
  "Физические лица по прямым договорам",
  "Прочие",
  "Транспорт"
]

export const value_group_vgo: string[] = [
  "Прочие",
  "Транспорт"
]

export const view_we: string[] = [
  "Сетевая вода",
  "Пар: 1,2-2,5 кг/см2",
  "Пар: 2,5-7,0 кг/см2",
  "Пар: 7,0-13,0 кг/см2",
  "Пар: >13 кг/см2",
  "Пар: остр. и редуцир."
]

export const tariffWarmEnergy = {
  "january": "january_we",
  "february": "february_we",
  "march": "march_we",
  "april": "april_we",
  "may": "may_we",
  "june": "june_we",
  "july": "july_we",
  "august": "august_we",
  "september": "september_we",
  "october": "october_we",
  "november": "november_we",
  "december": "december_we"
}

export const tariffWarmPower = {
  "january": "january_wp",
  "february": "february_wp",
  "march": "march_wp",
  "april": "april_wp",
  "may": "may_wp",
  "june": "june_wp",
  "july": "july_wp",
  "august": "august_wp",
  "september": "september_wp",
  "october": "october_wp",
  "november": "november_wp",
  "december": "december_wp"
}

export const periods: string[] = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december"
]

export const months_map: any = {
  "january": 1,
  "february": 2,
  "march": 3,
  "april": 4,
  "may": 5,
  "june": 6,
  "july": 7,
  "august": 8,
  "september": 9,
  "october": 10,
  "november": 11,
  "december": 12
}

export const months_indexes: any = {
  '0': 'january',
  '1': 'february',
  '2': 'march',
  '3': 'april',
  '4': 'may',
  '5': 'june',
  '6': 'july',
  '7': 'august',
  '8': 'september',
  '9': 'october',
  '10': 'november',
  '11': 'december'
}

export const reading_column: string[] = [
  "reading__main_pages", "reading__balance", "reading__cost_balance", "reading__transport", "reading__group_object_constructor", "reading__contractor", "reading__tariff", "reading__fb2__losses", "reading__fb2__usefull", "reading__ok"
]

export const editing_column: any = {
  editing__tariff: "editing__tariff",
  editing__contractor: "editing__contractor",
  editing__group_object_constructor: "editing__group_object_constructor",
  editing__rows: "editing__rows",
  editing__ok_hn: ["editing__ok_hn__ok", "editing__ok_hn__hn", "editing__ok_hn__tp", "editing__ok_hn__kp", "editing__ok_hn__tso_p"],
  editing__purchase: ["editing__purchase__volume", "editing__purchase__tariff"],
  editing__sale: ["editing__sale__volume", "editing__sale__tariff"],
  editing__transport_costs: ["editing__transport_costs__volume", "editing__transport_costs__tariff"],
  editing__transport_income: ["editing__transport_income__volume", "editing__transport_income__tariff"],
  editing__fb02: ["editing__fb02__tp", "editing__fb02__kp", "editing__fb02__tso_p", "editing__fb02__usefull"]
}

export const accept_column: any = {
  accept__mailing: ["accept__mailing"],
  accept__ok_hn: ["accept__ok_hn__ok", "accept__ok_hn__hn", "accept__ok_hn__tp", "accept__ok_hn__kp", "accept__ok_hn__tso_p"],
  accept__purchase: ["accept__purchase__volume", "accept__purchase__tariff"],
  accept__sale: ["accept__sale__volume", "accept__sale__tariff"],
  accept__transport_costs: ["accept__transport_costs__volume", "accept__transport_costs__tariff"],
  accept__transport_income: ["accept__transport_income__volume", "accept__transport_income__tariff"],
  accept__fb02: ["accept__fb02__tp", "accept__fb02__kp", "accept__fb02__tso_p", "accept__fb02__usefull"]
}

// Маппинг адреса страницы ввода данных и акцептируемых полей
export const route_accept_map: any = {
  losses: ["blocks__ok_hn__ok", "blocks__ok_hn__hn", "blocks__ok_hn__tp", "blocks__ok_hn__kp", "blocks__ok_hn__tso_p"],
  buy: ["blocks__purchase__volume", "blocks__purchase__tariff"],
  sale: ["blocks__sale__volume", "blocks__sale__tariff"],
  transport_cost: ["blocks__transport_costs__volume", "blocks__transport_costs__tariff"],
  transport_gain: ["blocks__transport_income__volume", "blocks__transport_income__tariff"],
}

// Значение при превышении которого подсвечивается флаг небаланса
export const IMBALANCE_ALARM_LIMIT = 0.00005

export const sort_property_tariff: any = {
  view: "view",
  sign_internal_turnover: "sign_internal_turnover",
  value_group: "value_group",
  id_heat_carrier: "id_heat_carrier",
  description: "description"
}

export const aggregate_periods: any = {
  year: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
  a_month: ["january"],
  two_months: ["january", "february"],
  three_months: ["january", "february", "march"],
  four_months: ["january", "february", "march", "april"],
  five_months: ["january", "february", "march", "april", "may"],
  six_months: ["january", "february", "march", "april", "may", "june"],
  seven_months: ["january", "february", "march", "april", "may", "june", "july"],
  eight_months: ["january", "february", "march", "april", "may", "june", "july", "august"],
  nine_months: ["january", "february", "march", "april", "may", "june", "july", "august", "september"],
  ten_months: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october"],
  eleven_months: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november"],
  twelve_months: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"],
  first_quarter: ["january", "february", "march"],
  second_quarter: ["april", "may", "june"],
  third_quarter: ["july", "august", "september"],
  thourth_quarter: ["october", "november", "december"],
  first_half: ["january", "february", "march", "april", "may", "june"],
  second_half: ["july", "august", "september", "october", "november", "december"],
  wane_a_month: ["december"],
  wane_two_months: ["december", "november"],
  wane_three_months: ["december", "november", "october"],
  wane_four_months: ["december", "november", "october", "september"],
  wane_five_months: ["december", "november", "october", "september", "august"],
  wane_six_months: ["december", "november", "october", "september", "august", "july"],
  wane_seven_months: ["december", "november", "october", "september", "august", "july", "june"],
  wane_eight_months: ["december", "november", "october", "september", "august", "july", "june", "may"],
  wane_nine_months: ["december", "november", "october", "september", "august", "july", "june", "may", "april"],
  wane_ten_months: ["december", "november", "october", "september", "august", "july", "june", "may", "april", "march"],
  wane_eleven_months: ["december", "november", "october", "september", "august", "july", "june", "may", "april", "march", "february"],
  wane_twelve_months: ["december", "november", "october", "september", "august", "july", "june", "may", "april", "march", "february", "january"],
}
